// src/components/HeroMenu.jsx
import React, { useMemo, useState } from "react";
import "./HeroMenu.css";
import AliveHover from "./AliveHover";

export default function HeroMenu() {
  const [active, setActive] = useState("projects");

  const items = useMemo(
    () => [
      { id: "projects", label: "Projects", target: "projects" },
      { id: "skills", label: "Skills", target: "skills" },
      { id: "experience", label: "Experience", target: "experience" },
    ],
    []
  );

  const go = (target, id) => {
    setActive(id);
    const el = document.getElementById(target);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <section className="hm" id="top">
      <div className="hm-bg" aria-hidden="true">
        <div className="hm-paint hm-paint-a" />
        <div className="hm-paint hm-paint-b" />
        <div className="hm-paint hm-paint-c" />
        <div className="hm-grain" />
        <div className="hm-vignette" />
      </div>

    <div className="hm-panel">
        <div className="hm-panel-frame" aria-hidden="true" />

        
        <div className="hm-inner">
        {/* LEFT: big “poster” nav */}
        <div className="hm-poster" aria-label="Site navigation">
          {/* <div className="hm-poster-title">MENU</div> */}

          <div className="hm-words">
            {items.map((it) => (
              <AliveHover key={it.id} className="hm-word-alive" strength={10}>
                <button
                  type="button"
                  className={`hm-word ${active === it.id ? "is-active" : ""}`}
                  onMouseEnter={() => setActive(it.id)}
                  onFocus={() => setActive(it.id)}
                  onClick={() => go(it.target, it.id)}
                >
                  <span className="hm-word-main">{it.label}</span>
                  <span className="hm-word-accent" aria-hidden="true" />
                </button>
              </AliveHover>
            ))}
          </div>

          <div className="hm-hint">Click to go • Scroll to continue</div>
        </div>

        {/* RIGHT: readable identity card */}
        <AliveHover className="hm-card hm-card-alive" strength={8}>
          <div className="hm-kicker">Hi, my name is</div>
          <h1 className="hm-name">Matthew Christopher Pohadi</h1>

          <div className="hm-role">
            I’m an aspiring <span>AI Software Developer</span>.
          </div>

          <p className="hm-desc">
            I build robust, scalable software that leverages AI to solve complex problems,
            especially agentic systems, automation, and retrieval-grounded tools.
          </p>

          <div className="hm-meta">
            <span className="hm-pill">CS @ SUTD</span>
            <a className="hm-pill" href="tel:+6594664619">
              +65 9466 4619
            </a>
            <a className="hm-pill" href="mailto:matthewchristopherpohadi@gmail.com">
              matthewchristopherpohadi@gmail.com
            </a>
          </div>

          <div className="hm-actions">
  <button
    type="button"
    className="hm-role hm-cta-link"
    onClick={() => go("projects", "projects")}
  >
    <span>View Projects</span>
    <span className="hm-cta-chevron" aria-hidden="true">↓</span>
  </button>
</div>



        </AliveHover>
      </div>
      </div>
      
    </section>
  );
}
